

























import { addBasePath } from '~/helpers/addBasePath';
import { SfImage } from './StorefrontUi';

export default {
  name: 'InfoWithIcon',
  components: {
    SfImage,
  },
  props: {
    info: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    smallRow: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      addBasePath,
    };
  },
};
